import { FC } from "react";
import { SubnetCalculator } from "@/components/SubnetCalculator";
import {
  Blocks,
  BuilderBlock,
  BuilderContextInterface,
  RegisteredComponents,
} from "@builder.io/sdk-react";

type SubnetCalculatorBlockProps = {
  headline: BuilderBlock[];
  addressBlockHeadline: string;
  allocationBlockHeadline: string;
  subnetsTableHeadline: string;
  builderBlock: BuilderBlock;
  builderComponents: RegisteredComponents;
  builderLinkComponent: unknown;
  builderContext: BuilderContextInterface;
};

export const SubnetCalculatorBlock: FC<SubnetCalculatorBlockProps> = ({
  headline,
  addressBlockHeadline,
  allocationBlockHeadline,
  subnetsTableHeadline,
  builderBlock,
  builderComponents,
  builderLinkComponent,
  builderContext,
}) => (
  <SubnetCalculator
    headline={
      <Blocks
        parent={builderBlock?.id}
        blocks={headline}
        path="headline"
        registeredComponents={builderComponents}
        linkComponent={builderLinkComponent}
        context={builderContext}
      />
    }
    addressBlockHeadline={addressBlockHeadline}
    allocationBlockHeadline={allocationBlockHeadline}
    subnetsTableHeadline={subnetsTableHeadline}
  />
);
